export default {"src":"/_next/static/media/configuration-audit.76a45010.svg","height":512,"width":384,"blurWidth":0,"blurHeight":0};